'use client'
import EditIcon from '@/app/icons/edit'
import UserContext from '@/context/user-context'
import useClientRender from '@/util/use-client-render'
import { useContext, useEffect } from 'react'
import { createPortal } from 'react-dom'
import { clearBulkEdit, setBulkEditOpen, useBulkEditOpen } from './bulk-edit-state'

const OpenButton = () => {
    return (
        <div className="hidden md:block fixed bottom-5 right-5">
            <div
                className="border-giphyGreen flex cursor-pointer items-center justify-center border-2 border-solid p-3  bg-giphyDarkestGrey"
                onClick={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    setBulkEditOpen(true)
                }}
            >
                <EditIcon className="fill-giphyWhite size-4" />
            </div>
        </div>
    )
}

const BulkEditButton = () => {
    const isEnabled = useBulkEditOpen()
    const { user } = useContext(UserContext)
    const isClient = useClientRender()
    useEffect(() => {
        return () => clearBulkEdit()
    }, [])
    return isClient && user?.permissions?.bulk_edit
        ? createPortal(isEnabled ? null : <OpenButton />, document.body)
        : null
}

export default BulkEditButton
